import { render, staticRenderFns } from "./MailingsBatch.vue?vue&type=template&id=55af34ba&scoped=true&"
import script from "./MailingsBatch.vue?vue&type=script&lang=ts&"
export * from "./MailingsBatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af34ba",
  null
  
)

export default component.exports